import { h } from "omi";

export function FileIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" fill="none">
      <path
        d="M9.3327 7.3333h-4M6.666 10H5.3327m5.3333-5.3334H5.3327m8-.1333v6.9333c0 1.1202 0 1.6802-.218 2.108a2.0004 2.0004 0 0 1-.874.8741c-.4279.2179-.9879.2179-2.108.2179H5.866c-1.12 0-1.6801 0-2.108-.2179a2 2 0 0 1-.874-.8741c-.218-.4278-.218-.9878-.218-2.108V4.5333c0-1.12 0-1.6801.218-2.108a2 2 0 0 1 .874-.874c.4279-.218.988-.218 2.108-.218h4.2667c1.1201 0 1.6801 0 2.108.218.3763.1918.6822.4977.874.874.218.4279.218.988.218 2.108Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
